/**
 * @module FE-CU53_ユーザー登録画面_本登録_コンポーネント
 */

// 氏名バリデーションエラー時のクラス指定
export function nameClass() {
  return {
    'bg-lightblue': !this.error.hasNameError,
    alert: this.error.hasNameError,
  };
}

// パスワードバリデーションエラー時のクラス指定
export function passwordClass() {
  return {
    'bg-lightblue': !this.error.hasPasswordError,
    alert: this.error.hasPasswordError,
  };
}

// 秘密の質問バリデーションエラー時のクラス指定
export function questionClass() {
  return {
    'bg-lightblue': !this.error.hasQuestionError,
    alert: this.error.hasQuestionError,
  };
}

// 回答(ひらがな)バリデーションエラー時のクラス指定
export function answerClass() {
  return {
    'bg-lightblue': !this.error.hasAnswerError,
    alert: this.error.hasAnswerError,
  };
}

// 性別(任意)バリデーションエラー時のクラス指定
export function genderClass() {
  return {
    'bg-lightblue': !this.error.hasGenderError,
    alert: this.error.hasGenderError,
  };
}

// 生年(任意)バリデーションエラー時のクラス指定
export function birthyearClass() {
  return {
    'bg-lightblue': !this.error.hasBirthyearError,
    alert: this.error.hasBirthyearError,
  };
}

// 回答(ひらがな)バリデーション用正規表現パターン
export function hiraganaPattern() {
  // ひらがなのみを許容する
  return /^[\u3041-\u3094]+$/;
}

// パスワードバリデーション用正規表現パターン
export function passwordPattern() {
  // 半角で英字大文字、小文字、数字と記号をそれぞれ１つ以上使わなければならない
  return /^((?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])|(?=.*[a-z])(?=.*[A-Z])(?=.*?[!-/:-@[-`{-~])|(?=.*[A-Z])(?=.*[0-9])(?=.*?[!-/:-@[-`{-~])|(?=.*[a-z])(?=.*[0-9])(?=.*?[!-/:-@[-`{-~]))([!-~]){8,}$/;
}
